export const getSwatches = state => state.facet.swatches;
